import { useFormikContext } from "formik";
import { useRouter } from "next/router";
import { EDITOR_MODE } from "utils/constants/editor";
import { MANIFEST_CONTEXT_TYPE } from "utils/constants/manifest";
import { useGroupedAppEntities } from "utils/selectors";
import {
  getFormEntity,
  getPricingTableEntity,
  useFormCombinations,
  useFormFieldGroups
} from "../manifest";
import {
  getCheckoutConfig,
  getControlsConfig,
  getFormConfig,
  getOtherConfig
} from "./form";

export const useManifestCommands = () => {
  const { values, setValues, setFieldTouched } = useFormikContext();
  const router = useRouter();
  const combinations = useFormCombinations();
  const fieldGroups = useFormFieldGroups();
  const entities = useGroupedAppEntities();
  const commonFocus = {
    values,
    setValues,
    setFieldTouched
  };
  const commonContext = {
    mode: EDITOR_MODE.INSPECT
  };

  const context = values.manifest.context;
  const isFormContext = context === MANIFEST_CONTEXT_TYPE.FORM;
  const isPricingContext = context === MANIFEST_CONTEXT_TYPE.PRICING;

  let primaryEntity;
  if (isFormContext) {
    primaryEntity = getFormEntity(values);
  } else if (isPricingContext) {
    primaryEntity = getPricingTableEntity(values);
  }
  if (primaryEntity) {
    commonContext.uuid = primaryEntity.uuid;
  }

  const controlsConfig = getControlsConfig({
    commonContext,
    commonFocus
  });
  if (isFormContext) {
    const checkoutConfig = getCheckoutConfig({
      combinations,
      commonContext,
      commonFocus
    });

    const formConfig = getFormConfig({
      entities,
      fieldGroups,
      commonContext,
      commonFocus,
      schema: primaryEntity.schema
    });

    const otherConfig = getOtherConfig({ commonContext, commonFocus, router });
    return [
      ...checkoutConfig,
      ...formConfig,
      ...controlsConfig,
      ...otherConfig
    ];
  } else if (isPricingContext) {
    return [...controlsConfig];
  } else {
    return [...controlsConfig];
  }
};
